/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Type_WithdrawalInputs */

const en_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawal`)
};

const de_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerruf`)
};

const fr_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rétractation`)
};

const es_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desistimiento`)
};

const it_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recesso`)
};

const nl_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herroeping`)
};

const pl_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstąpienie`)
};

const fi_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuttaminen`)
};

const da_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortrydelse`)
};

const sv_consumer_declaration_type_withdrawal = /** @type {(inputs: Consumer_Declaration_Type_WithdrawalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ångerrätt`)
};

/**
* | output |
* | --- |
* | "Withdrawal" |
*
* @param {Consumer_Declaration_Type_WithdrawalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_type_withdrawal = /** @type {((inputs?: Consumer_Declaration_Type_WithdrawalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Type_WithdrawalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_type_withdrawal(inputs)
	if (locale === "fr") return fr_consumer_declaration_type_withdrawal(inputs)
	if (locale === "es") return es_consumer_declaration_type_withdrawal(inputs)
	if (locale === "it") return it_consumer_declaration_type_withdrawal(inputs)
	if (locale === "nl") return nl_consumer_declaration_type_withdrawal(inputs)
	if (locale === "pl") return pl_consumer_declaration_type_withdrawal(inputs)
	if (locale === "fi") return fi_consumer_declaration_type_withdrawal(inputs)
	if (locale === "da") return da_consumer_declaration_type_withdrawal(inputs)
	if (locale === "sv") return sv_consumer_declaration_type_withdrawal(inputs)
	return en_consumer_declaration_type_withdrawal(inputs)
});